

const TransactionFiltersSkeleton = () => (
  <div className="mb-4 p-3 p-md-4 bg-white rounded-3 border shadow-sm skeleton-container">
    {/* Header skeleton */}
    <div className="skeleton-line mb-3" style={{ width: '120px', height: '20px' }} />
    
    {/* Mobile layout skeleton */}
    <div className="d-flex d-md-none flex-column gap-3 mb-3">
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="input-group input-group-sm">
          <div className="skeleton-line" style={{ width: '40px', height: '36px' }} />
          <div className="skeleton-line flex-grow-1 ms-2" style={{ height: '36px', borderRadius: '6px' }} />
        </div>
      ))}
    </div>

    {/* Desktop layout skeleton */}
    <div className="d-none d-md-block">
      <div className="row g-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="col-md-6 col-lg-3">
            <div className="skeleton-line mb-2" style={{ width: '60px', height: '12px' }} />
            <div className="input-group">
              <div className="skeleton-line" style={{ width: '42px', height: '38px' }} />
              <div className="skeleton-line flex-grow-1 ms-2" style={{ height: '38px', borderRadius: '6px' }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default TransactionFiltersSkeleton;
